import React from "react";
import { Grid } from "@mui/material";
import "./ranking.css";
import RankingCard from "./RankingCard";
function Ranking() {
  const aBtnData = [
    {
      btnName: "Games",
    },
    {
      btnName: "Art",
    },
    {
      btnName: "Trading Cards",
    },
    {
      btnName: "Music",
    },
    {
      btnName: "Meme",
    },
    {
      btnName: "Domains Names",
    },
    {
      btnName: "Collectible",
    },
  ];
  return (
    <div className="activity_main">
      <h1 className="activity_head">Ranking NFT</h1>

      <Grid container justifyContent="center">
        <Grid item lg={9}>
          <div className="activity_btns">
            {aBtnData.map((e) => {
              return <button className="a_btn">{e.btnName}</button>;
            })}
          </div>
        </Grid>
      </Grid>
      {/*  */}
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={10}>
          {/*  */}
          <div className="bg_dark">
            <Grid container justifyContent="space-between">
              <Grid item lg={2}>
                <div className="recent_a">
                  <p className="activity_recent">Recent Active</p>
                  <span className="dropdow_a">
                    <img src="./Assets/CaretDown.png" alt="" />
                  </span>
                </div>
              </Grid>
              <Grid item lg={2}>
                <p className="mark_read">Mark All Read</p>
              </Grid>
            </Grid>
            <RankingCard />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default Ranking;
